import { createSlice } from '@reduxjs/toolkit';
import { MOCK_USERS } from '../data/mockData';
import { ROLES } from '../constants/status';

const initialState = {
  user: {}, // MOCK — replace with session validation
  role: "",
  token: null,
  isAuthenticated: !!localStorage.getItem("isLoggedIn"),
  isLocationEnabled: localStorage.getItem("isLocationEnabled") === "true",
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.role = action.payload.role;
      state.token = action.payload.token;
    },
    setRole(state, action) {
      // MOCK only — in production, role comes from the auth token
      state.role = action.payload;
    },
    // AUTH: Called on sign out — clear sessionStorage token
    logout(state) {
      state.isAuthenticated = false;
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("isLocationEnabled"); 
      state.user = null;
      state.role = null;
      state.token = null;
    },
    // AUTH: Wire save to PUT /api/users/:id { email, phone, smsNumber }
    updateProfile(state, action) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    setLocationEnabled: (state, action) => {
      state.isLocationEnabled = action.payload;
      localStorage.setItem("isLocationEnabled", action.payload);
    },
  },
});

export const { setUser, setRole, logout, updateProfile, setLocationEnabled } = authSlice.actions;
export default authSlice.reducer;
